<template>
    <div class="py-4 container-fluid">
        <transition name="banner-slide">
            <div v-if="isSyncing || progress === 100">
                <RvoSyncBanner />
            </div>
        </transition>

        <div class="row">
            <div class="col-lg-12">
                <div class="row mt-4">
                    <div class="multisteps-form mb-9">
                        <div class="col-12 col-lg-10 m-auto">
                            <div class="card">
                                <div class="card-header p-0 position-relative mt-n4 mx-3 z-index-2">
                                    <div class="bg-gradient-success shadow-success border-radius-lg pt-4 pb-3">
                                        <div class="multisteps-form__progress">
                                            <button class="multisteps-form__progress-btn" type="button"
                                                :disabled="isSyncing"
                                                :title="$t('eartag.Step1')"
                                                :class="activeStep >= 0 ? activeClass : ''"
                                                @click="activeStep = 0">
                                                <span>{{ $t('eartag.Step1') }}</span>
                                            </button>                                             
                                            <button class="multisteps-form__progress-btn" type="button"
                                                :title="$t('eartag.Step2')" 
                                                :class="activeStep >= 1 ? activeClass : ''"
                                                @click="activeStep = 1">
                                                <span>{{ $t('eartag.Step2') }}</span>
                                            </button>
                                            <button class="multisteps-form__progress-btn" type="button" 
                                                :title="$t('eartag.Step3')"
                                                :class="activeStep >= 2 ? activeClass : ''" @click="activeStep = 2">
                                                {{ $t('eartag.Step3') }}
                                            </button>
                                            <button class="multisteps-form__progress-btn" type="button" 
                                                :title="$t('eartag.Step4')"
                                                :class="activeStep >= 3 ? activeClass : ''" @click="activeStep = 3">
                                                {{ $t('eartag.Step4') }}
                                            </button>
                                        </div>
                                    </div>
                                </div>
                                <div class="card-body">
                                    <form class="multisteps-form__form" @submit.prevent="submitForm">
                                        <animal-info 
                                            v-if="activeStep === 0" 
                                            :class="activeStep === 0 ? activeClass : ''"
                                            :formData="formData" 
                                            :nextStep="nextStep"                                            
                                            :animals="formData.animals"
                                            :noEartagAvailable="noEartagAvailable"
                                            :rVOMessage="rVOMessage"
                                            @update:formData="updateFormData"
                                        />
                                        <tag-info 
                                            v-if="activeStep === 1" 
                                            :class="activeStep === 1 ? activeClass : ''"
                                            :formData="formData" 
                                            :prevStep="prevStep"
                                            :nextStep="nextStep"
                                            :tags="formData.tags"
                                            @update:formData="updateFormData"
                                        />
                                        <date-info 
                                            v-if="activeStep === 2" 
                                            :class="activeStep === 2 ? activeClass : ''"                                            
                                            :formData="formData"
                                            :prevStep="prevStep"
                                            :nextStep="nextStep"                                            
                                            @update:formData="updateFormData"
                                        />
                                        <confirm-info
                                            v-if="activeStep === 3" 
                                            :class="activeStep === 3 ? activeClass : ''"
                                            :formData="formData"                                                                   
                                            :prevStep="prevStep"
                                            :emitter="emitter"
                                            ref="confirmInfoRef" 
                                        />
                                        <div class="button-row d-flex align-items-center">
                                            <p v-if="rVOMessageCU" class="text-danger text-sm mb-0 me-3">
                                                {{ rVOMessageCU }}
                                            </p>

                                            <button
                                                v-if="activeStep === 3"
                                                @click="saveForm"
                                                class="btn mb-0 btn-sm bg-gradient-success ms-auto"
                                                type="button">
                                                {{ $t('common.Save') }}
                                            </button>

                                        </div>                                        
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="row"></div>
    </div>
</template>

<script>

import AnimalInfo from "./components/Animal.vue";
import TagInfo from "./components/Tag.vue";
import DateInfo from "./components/Date.vue";
import ConfirmInfo from "./components/Confirm.vue";
import RvoSyncBanner from "@/components/RvoSyncBanner.vue";

import * as Choices from "choices.js";
import { nextTick } from 'vue'
import axios from 'axios'
import mitt from 'mitt';
import { mapState, mapGetters } from 'vuex'

export default {
    name: 'Retagging_page',
    data() {
        return {
            emitter: mitt(),
            activeStep: 0,
            activeClass: "js-active position-relative",            
            formSteps: 4,
            noEartagAvailable: false,
            rVOMessage: '',
            rVOMessageCU: '',
            formData: {                
                animalId: '',
                animalDetails: '',
                tagId: '',
                tagDetails: '',
                reTagDate: null,
                animals:[],
                tags:[],
            },
            // Store Choices instance            
            choicesInstanceAnimal: null,
            choicesInstanceTag: null         
        };
    },
    components: {
        AnimalInfo,
        TagInfo,
        DateInfo,
        ConfirmInfo,
        RvoSyncBanner
    },
    async mounted() {
        try {
            let response;

            const role = this.$store.state.roleName;
            const rVOConnected = this.$store.state.keeperRVOConnected;
            const rVORelationNumber = this.$store.state.keeperRVORelationNumber;
            const associationId = this.$store.state.associationAdminAssociationId;

            const cancelSource = axios.CancelToken.source();

            if (role === 'Admin' || role === 'AssociationAdmin') {

                // START simulated progress
                this.$store.commit('rvoSync/START_SYNC', cancelSource);

                response = await axios.get(
                    `/rvo/syncrvoeartags?associationId=${associationId}`,
                    {
                        cancelToken: cancelSource.token
                    }
                );

                // STOP simulated progress
                this.$store.commit('rvoSync/STOP_SYNC');
            }
            else if (role === 'Keeper') {
                if (rVOConnected && rVORelationNumber !== '') {

                    this.$store.commit('rvoSync/START_SYNC', cancelSource);

                    response = await axios.get('/rvo/syncrvoeartags', {
                        params: {
                            rVORelationNumber: rVORelationNumber,
                            inrelato: "Eartags for retagging (RVO/I&R)"
                        },
                        cancelToken: cancelSource.token
                    });

                    this.$store.commit('rvoSync/STOP_SYNC');

                } else {
                    this.$showSuccess(
                        this.$t('rvo.RVO_Synchronization_is_not_possible_without_user_mandate')
                    );
                    
                    await this.fetchAllAnimals();
                    return;
                }
            } 
            else {
                console.warn('No valid role for RVO sync');
                await this.fetchAllAnimals();
                return;
            }
            
            if (response) {
                const result = response.data;                

                if (result.success) {                    
                    if (result.count > 0) { 
                        this.noEartagAvailable = false;
                        await this.fetchAllAnimals();
                    } else {   
                        this.noEartagAvailable = true;
                        this.rVOMessage = this.$t('rvo.' + result.message);
                        this.$showSuccess(this.$t('rvo.' + result.message));
                    }
                    await this.fetchAllAnimals();
                } else {   
                    this.noEartagAvailable = true;
                    this.rVOMessage = this.$t('rvo.' + result.message);
                    this.$showError(this.$t('rvo.' + result.message));       
                }
            } else {  
                this.noEartagAvailable = false;              
                await this.fetchAllAnimals();
            }

        } catch (e) {

            if (axios.isCancel(e)) {
                console.warn("Sync cancelled by user");
                return;
            }

            this.$store.commit('rvoSync/STOP_SYNC');

            const errorMessage =
                e.response?.data?.message ||
                e.message ||
                this.$t('errors.Something_went_wrong');

            this.$showError(
                `${this.$t('errors.Contact_system_admin')}: ${errorMessage}`
            );

            await this.fetchAllAnimals();
        }
    },
    computed: {
        userRoleName() {
            return this.$store.state.user?.roleName;
        },
        ...mapState('rvoSync', ['isSyncing', 'progress', 'cancelSource']),
        ...mapGetters('rvoSync', ['elapsedSeconds']),

        alertClass() {
            return this.elapsedSeconds > 15
                ? 'alert-warning'
                : 'alert-info';
        },

        elapsedFormatted() {
            const sec = this.elapsedSeconds;
            const minutes = Math.floor(sec / 60);
            const seconds = sec % 60;

            return `${minutes}:${seconds.toString().padStart(2, '0')}`;
        },

        isCompleted() {
            return this.progress === 100;
        }
    },
    methods: {
        async nextStep() {
            if (this.activeStep < this.formSteps -1) {
                this.activeStep += 1;
            } else {
                this.activeStep -= 1;
            }   

            if(this.activeStep == 1) {                
                await this.fetchAllTags();
            }            
        },
        async prevStep() {
            if (this.activeStep > 0) {
                this.activeStep -= 1;
                //console.log(this.activeStep);

                if(this.activeStep == 0) {                    
                    await this.fetchAllAnimals();
                }
                
                if(this.activeStep == 1) {
                    await this.fetchAllTags();
                }

                this.rVOMessageCU = '';
            }
        },        
        async fetchAllAnimals() 
        {
            try { 
                this.$store.commit('setShowLoading', true);
                
                const ubn = this.$store.state.keeperUBN;

                const response = await axios.get("Animal/getallretagging", {
                    params: {                        
                        ubn
                }});

                const result = response.data;

                if (result.success) {
                    if(result.count > 0 && Array.isArray(result.data)) {
                        this.formData.animals = result.data.sort((a, b) => (b.animalNumber ?? '').localeCompare(a.animalNumber ?? ''));                        
                    } else {
                        this.$showSuccess('errors.Success_no_animal_found');
                    }
                } else {
                    this.$showError(this.$t('errors.Error_fetching_animals'));
                }               
            } catch (e) {
                const errorMessage = e.response?.data?.message || e.message || this.$t('errors.Something_went_wrong');
                this.$showError(`${this.$t('errors.Contact_system_admin')}: ${errorMessage}`);
            } finally {
                this.$store.commit('setShowLoading', false);
            }
        },  
        async syncRVOEartag()
        {
            let response;

            const role = this.$store.state.roleName;                
            const rVOConnected = this.$store.state.keeperRVOConnected;
            const rVORelationNumber = this.$store.state.keeperRVORelationNumber;
            const associationId = this.$store.state.associationAdminAssociationId;

            if (role === 'Admin' || role === 'AssociationAdmin') {
                response = await axios.get(`/rvo/syncrvoeartags?associationId=${associationId}`);
            } else if (role === 'Keeper') {
                if(rVOConnected)
                {
                    if(rVORelationNumber != '')
                    {
                        response = await axios.get(`/rvo/syncrvoeartags?rvorelationnumber=${rVORelationNumber}`);
                    }
                    else
                    {
                        this.$showError(this.$t('rvo.RVO_Synchronization_is_not_possible_without_user_mandate'));
                    }                    
                }
            } else {
                console.warn('No role');
                return;
            }
            
            if (!response.data.success) {
                this.$showError(this.$t('errors.RVO_eartag_syncronization_failed'));
                this.activeStep = 0;
                await this.fetchAllAnimals();
            }
        },
        getSelectedAnimalNumber() {
            const selectedAnimal = this.formData.animals.find(
                a => a.id === this.formData.animalId
            );

            return selectedAnimal ? selectedAnimal.animalNumber : null;
        },
        getSelectedTagWorkNumber() {
            const selectedTag = this.formData.tags.find(
                a => a.id === this.formData.tagId
            );

            return selectedTag ? selectedTag.workNumber : null;
        },
        async syncRVOCheckRetagging() {
            let response;

            const role = this.$store.state.roleName;
            const rVOConnected = this.$store.state.keeperRVOConnected;
            const rVORelationNumber = this.$store.state.keeperRVORelationNumber;

            if (role !== 'Keeper') {
                console.warn('No role');
                return false;
            }

            if (!rVOConnected || !rVORelationNumber) {
                this.$showError(
                    this.$t('rvo.RVO_retagging_check_is_not_possible_without_user_mandate')
                );
                return false;
            }

            const ubn = this.$store.state.keeperUBN;
            const animalId = this.formData.animalId;
            const retaggingDate = this.formData.reTagDate;
            const animalWorkNumber = this.getSelectedAnimalNumber();
            const newTagWorkNumber = this.getSelectedTagWorkNumber();

            if (!ubn || !animalWorkNumber || !newTagWorkNumber || !retaggingDate) {
                this.$showError(this.$t('rvo.Missing_required_retagging_check_parameters'));
                return false;
            }

            const formattedDate = new Date(retaggingDate).toISOString();

            // ===== START PROGRESS BANNER =====
            const cancelSource = axios.CancelToken.source();
            this.$store.commit('rvoSync/START_SYNC', cancelSource);

            try {
                response = await axios.get('/rvo/syncrvoverifyretagging', {
                    params: {
                        rVORelationNumber: rVORelationNumber,
                        animalUbn: ubn,
                        animalId: animalId,
                        animalWorkNumber: animalWorkNumber,
                        newTagWorkNumber: newTagWorkNumber,
                        retaggingDate: formattedDate
                    },
                    cancelToken: cancelSource.token
                });

                // ===== STOP PROGRESS BANNER =====
                this.$store.commit('rvoSync/STOP_SYNC');

                if (!response.data.success) {
                    this.$showError(response.data.message);
                    this.rVOMessageCU = response.data.message;
                    return false;
                }

                this.$showSuccess(this.$t('rvo.RVO_retagging_check_success'));
                return true;

            } catch (e) {

                if (axios.isCancel(e)) {
                    console.warn("RVO retagging check cancelled by user");
                    return false;
                }

                this.$store.commit('rvoSync/STOP_SYNC');

                const errorMessage =
                    e.response?.data?.message ||
                    e.message ||
                    this.$t('errors.Something_went_wrong');

                this.$showError(
                    `${this.$t('errors.Contact_system_admin')}: ${errorMessage}`
                );

                return false;
            }
        },
        async syncRVOUpdateRetagging(animalTagHistoryId) {
            let response;

            const role = this.$store.state.roleName;
            const rVOConnected = this.$store.state.keeperRVOConnected;
            const rVORelationNumber = this.$store.state.keeperRVORelationNumber;

            if (role !== 'Keeper') {
                console.warn('No role');
                return false;
            }

            if (!rVOConnected || !rVORelationNumber) {
                this.$showError(
                    this.$t('rvo.RVO_retagging_check_is_not_possible_without_user_mandate')
                );
                return false;
            }

            const ubn = this.$store.state.keeperUBN;
            const animalId = this.formData.animalId;
            const retaggingDate = this.formData.reTagDate;
            const animalWorkNumber = this.getSelectedAnimalNumber();
            const newTagWorkNumber = this.getSelectedTagWorkNumber();

            if (!ubn || !animalWorkNumber || !newTagWorkNumber || !retaggingDate) {
                this.$showError(this.$t('rvo.Missing_required_retagging_check_parameters'));
                return false;
            }

            const formattedDate = new Date(retaggingDate).toISOString();

            // ===== START PROGRESS BANNER =====
            const cancelSource = axios.CancelToken.source();
            this.$store.commit('rvoSync/START_SYNC', cancelSource);

            try {
                response = await axios.get('/rvo/syncrvoupdateretagging', {
                    params: {
                        rVORelationNumber: rVORelationNumber,
                        animalUbn: ubn,
                        animalId: animalId,
                        animalWorkNumber: animalWorkNumber,
                        newTagWorkNumber: newTagWorkNumber,
                        retaggingDate: formattedDate,
                        animalTagHistoryId: animalTagHistoryId
                    },
                    cancelToken: cancelSource.token
                });

                // ===== STOP PROGRESS BANNER =====
                this.$store.commit('rvoSync/STOP_SYNC');

                if (!response.data.success) {
                    this.$showError(response.data.message);
                    this.rVOMessageCU = response.data.message;
                    return false;
                }

                this.$showSuccess(this.$t('rvo.RVO_retagging_update_success'));
                return true;

            } catch (e) {

                if (axios.isCancel(e)) {
                    console.warn("RVO retagging update cancelled by user");
                    return false;
                }

                this.$store.commit('rvoSync/STOP_SYNC');

                const errorMessage =
                    e.response?.data?.message ||
                    e.message ||
                    this.$t('errors.Something_went_wrong');

                this.$showError(
                    `${this.$t('errors.Contact_system_admin')}: ${errorMessage}`
                );

                return false;
            }
        },
        async fetchAllTags()
        {
            this.$store.commit('setShowLoading', true);
            try { 

                let response;
                
                const role = this.$store.state.roleName;                
                const rVORelationNumber = this.$store.state.keeperRVORelationNumber;

                if (role === 'Admin' || role === 'AssociationAdmin') {
                    response = await await axios.get("eartag/getall");
                } else if (role === 'Keeper') {
                    response = await axios.get(`/eartag/getbyrvorelationnumber?rvorelationnumber=${rVORelationNumber}`)
                } else {
                    console.warn('No role');
                    return;
                }
                      
                const apiResult = response.data;

                if (apiResult.success && Array.isArray(apiResult.data)) {

                    this.formData.tags = apiResult.data.sort((a, b) => {
                        if (!a.tagNumber) return 1;
                        if (!b.tagNumber) return -1;

                        const numA = parseInt(a.tagNumber, 10);
                        const numB = parseInt(b.tagNumber, 10);

                        if (!isNaN(numA) && !isNaN(numB)) {
                            return numA - numB;
                        }

                        return a.tagNumber.localeCompare(b.tagNumber);
                    });

                    await nextTick();

                    this.initializeChoicesDropdown({
                        id: "tagId",
                        dataList: this.formData.tags,
                        selectedValue: this.formData.tagId,
                        instanceKey: "choicesInstanceTag"
                    });
                } else {    
                    this.$showSuccess('errors.Error_fetching_tags');
                }   
            } catch (e) {
                const errorMessage = e.response?.data?.message || e.message || this.$t('errors.Something_went_wrong');
                this.$showError(`${this.$t('errors.Contact_system_admin')}: ${errorMessage}`);
            } finally {
                this.$store.commit('setShowLoading', false);
            }
        },                            
        initializeChoicesDropdown({ id, dataList, selectedValue, instanceKey }) {
            const element = document.getElementById(id);
            if (!element || element.tagName !== "SELECT") {
                console.error(`Choices: Invalid or missing select element with ID "${id}".`);
                return;
            }

            // Destroy previous instance if it exists
            if (this[instanceKey]) {
                this[instanceKey].destroy();
            }

            // Initialize new Choices instance
            this[instanceKey] = new Choices(element, {
                searchEnabled: true,
                itemSelectText: '',
                shouldSort: false,
                placeholder: true,
            });

            // Set selected value if it exists in list
            if (selectedValue) {
                const optionExists = dataList.some(item => item.id === selectedValue);
                this[instanceKey].setChoiceByValue(optionExists ? [selectedValue] : '');
            }
        },
        updateFormData(updatedData) {
            //this.formData = { ...this.formData, ...updatedData };
            Object.assign(this.formData, updatedData);
        },        
        async saveForm() {

            // 1. Validate UI form first
            const isValid = await this.$refs.confirmInfoRef?.validateAndSubmit();
            if (!isValid) return;

            // 2. Run RVO check BEFORE actual submit
            const rvoCheckOk = await this.syncRVOCheckRetagging();

            // 3. If RVO check failed – stop submission
            if (!rvoCheckOk) {
                return;
            }

            // 4. Only submit when RVO validation passed
            const submitResult = await this.submitForm();
             if (!submitResult.success) {                
                return;
            }

            // 5. Run RVO update after submit
            const rvoUpdateOk = await this.syncRVOUpdateRetagging(submitResult.data.id);            
            if (!rvoUpdateOk) {
                return;
            }

            // 6. Everything succeeded
            this.$showSuccess(this.$t('errors.Retagging_updated_successfully'));
            this.$router.push('/retagging');
        },
        async submitForm() {
            try {
                this.$store.commit('setShowLoading', true);

                //animalId: '',
                //tagId: '',
                //reTagDate: null,

                const formData = new FormData();
                const ignoredKeys = [
                    'animals', 'tags', 'tagDetails', 'animalDetails'
                ];

                for (const key of Object.keys(this.formData)) {
                    if (ignoredKeys.includes(key)) continue;

                    const value = this.formData[key];
                    const isDateField = ['reTagDate'];

                    if (isDateField.includes(key) && value instanceof Date) {
                        formData.append(key, value.toISOString().split('T')[0]);
                    } else if (value !== null && value !== undefined) {
                        formData.append(key, value);
                    }
                }
               
                if (this.$store.state.keeperRVORelationNumber) {
                    formData.append('KeeperRelationNumber', this.$store.state.keeperRVORelationNumber);
                }

                if (this.$store.state.keeperUBN) {
                    formData.append('KeeperUbn', this.$store.state.keeperUBN);
                }

                // Debug formData before sending
                for (let pair of formData.entries()) {
                    console.log(pair[0], pair[1]);
                }

                const response = await axios.post('/eartag/retagging', formData, {
                    headers: { 'Content-Type': 'multipart/form-data' }
                });

                const result = response.data;

                return {
                    success: result.success,
                    data: result.data
                };
            } catch (e) {
                const errorMessage =
                    e.response?.data?.message ||
                    e.message ||
                    this.$t('errors.Something_went_wrong');

                this.$showError(
                    `${this.$t('errors.Contact_system_admin')}: ${errorMessage}`
                );

                return {
                    success: false,
                    error: errorMessage
                };

            } finally {
                this.$store.commit('setShowLoading', false);
            }
        },
        cancelSync() {
            if (!this.cancelSource) return;

            this.$store.commit('rvoSync/CANCEL_SYNC');
            this.$showError(this.$t('rvo.sync_cancelled'));
        }
    }
}
</script>
<style>
    .choices[data-type*=select-one]::after {
    display: none !important;
    }

    .choices__inner {
    border: none !important;
    background-color: transparent !important;
    box-shadow: none !important;
    position: relative;
    }

    .choices[data-type*=select-one] .choices__inner::before {
    content: "";
    position: absolute;
    right: 12px;
    top: 50%;
    width: 0;
    height: 0;
    pointer-events: none;
    border-left: 6px solid transparent;
    border-right: 6px solid transparent;
    border-top: 6px solid #666;
    transform: translateY(-50%);
    }

    /* Hide weird characters or fallback icons */
    .choices__inner > *:not(.choices__item) {
    font-family: inherit !important;
    content: none !important;
    }


    .choices__placeholder {
    color: #999;
    font-style: italic;
    }

    .choices__list--single {
    padding: 0px !important;
    }

    .banner-slide-enter-active,
    .banner-slide-leave-active {
        transition: all 0.8s ease;
        overflow: hidden;
    }

    .banner-slide-enter-from,
    .banner-slide-leave-to {
        opacity: 0;
        max-height: 0;
        margin-bottom: 0;
    }

    .banner-slide-enter-to,
    .banner-slide-leave-from {
        opacity: 1;
        max-height: 200px; /* large enough to fit banner */
        margin-bottom: 1rem;
    }
</style>